import { addBreadcrumb } from "@sentry/react";

export const addSentryBreadcrumb = (breadcrumb: Parameters<typeof addBreadcrumb>[0]): void => {
  addBreadcrumb(breadcrumb);
};
